module.exports = __webpack_public_path__ + "img/favicon.2e7940e1.png";